import successAudio from "../../assets/audio/scanner_beep.mp3"
import scanAudio from "../../assets/audio/success_beep.mp3"

let SoundFactory = function () {
    let successBeep = () => {
        return successAudio;
    }

    let errorBeep = () => {
        return scanAudio;
    }

    let playSuccessBeep = (id) => {
        document.querySelector(id).play();
    }

    let PlayErrorBeep = (id) => {
        document.querySelector(id).play();
    }

    return {
        successBeep,
        errorBeep,
        playSuccessBeep,
        PlayErrorBeep
    }
}

export default SoundFactory


// WEBPACK FOOTER //
// ./client/app/common/sound/sound.factory.js